module.exports = __webpack_public_path__ + "static/media/3DPPA2.21d7afdf.jpg";